import React from 'react';
import { GridItem, Button, VStack, Text, Flex, CircularProgress, HStack, Box } from '@chakra-ui/react';
import { IconButton } from '@mui/material';
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { motion, AnimatePresence } from 'framer-motion';
import { AssignmentOutlined, CheckCircleOutlined, KeyboardArrowDown, KeyboardArrowRight, KeyboardArrowUp } from '@mui/icons-material';

const BottomLeft = ({
  sectionData, 
  selectedSection, setSelectedSection, 
  setScrollToQuestionCard, 
  setSelectedTab, 
  isCollaborator,
  selectedFilter, setSelectedFilter,
  taskName,
}) => {
  function getUnfilledAnswers(section) {
    console.log("[Form][BottomLeft] section data is", section)
    let count = 0;
    for (let i = 0; i < section.fill_response?.length; i++) {
      if (section.fill_response[i].state == "unfilled") {
        count++
      }
    }

    for (let i = 0; i < section.review_response?.length; i++) {
      if (section.review_response[i].state == "unfilled") {
        count++
      }
    }

    return count
  }

  function getUnreviewedAnswers(section) {
    console.log("[Form][BottomLeft] section data is", section)
    let count = 0;
    for (let i = 0; i < section.fill_response?.length; i++) {
      if (section.fill_response[i].state == "unapproved") {
        count++
      }
    }

    for (let i = 0; i < section.review_response?.length; i++) {
      if (section.review_response[i].state == "unapproved") {
        count++
      }
    }

    return count
  }

  function getCompletedAnswers(section) {
    console.log("[Form][BottomLeft] section data is", section)
    let count = 0;
    for (let i = 0; i < section.fill_response?.length; i++) {
      if (section.fill_response[i].state == "approved") {
        count++
      }
    }

    for (let i = 0; i < section.review_response?.length; i++) {
      if (section.review_response[i].state == "approved") {
        count++
      }
    }

    return count
  }

  function getPercentageComplete(section) {
    let count = 0;
    for (let i = 0; i < section.fill_response?.length; i++) {
      if (section.fill_response[i].state == "approved") {
        count++
      }
    }
    for (let i = 0; i < section.review_response?.length; i++) {
      if (section.review_response[i].state == "approved") {
        count++
      }
    }

    let total = (section.fill_response?.length || 0) + (section.review_response?.length || 0);
    if (total == 0) {
      return 0
    }
    
    console.log("[Form][BottomLeft] count and total is", count, total)
    let percentage = (count / total) * 100;
    return percentage
  }

    return (
      <GridItem area="pagelist" bg="white" p={"24px"} overflowY="auto" display="flex" flexDirection="column" justifyContent="space-between">
      <VStack align="start" spacing={"16px"} width={"100%"}>
        <HStack
          height={"24px"}
          gap={"2px"}
          width={"100%"}
        >
          <IconButton
            sx={{ padding:0, fontSize: "16px", color: "#3D3D3D"}}
          >
            <AssignmentOutlined sx={{ padding:0, fontSize: "16px", color: "#3D3D3D" }}/>
          </IconButton>
          <Text fontFamily={"sans-serif"} fontSize={"16px"} fontWeight={"600"} isTruncated>
            {taskName}
          </Text>
        </HStack>
        {sectionData?.sort((a,b) => a.index - b.index).map((data, i) => (
        <VStack
          spacing={"12px"}
          w={"100%"}
        >
          <Button
            justifyContent={"space-between"}
            colorScheme="#F6FAFF"
            border="none"
            borderRadius="0"
            color= {selectedSection == i ? "#1d1d1d" : "#5d5d5d"}
            width="100%"
            _hover={{
              color: '#2584fd',
            }}
            key={i}
            onClick={() => { setSelectedSection(i); 
              selectedSection == i && setSelectedFilter("all") 
            }}
            fontWeight={selectedSection == i ? "medium" : "regular"}
            fontFamily={"sans-serif"}
            padding={0}
            height={"24px"}
          >
            <HStack
              width={"100%"}
              display={"flex"}
              justifyContent={"space-between"}
            >
              <HStack gap={"3px"} width={getPercentageComplete(data) < 100 ? `calc(100% - 68px)` : `calc(100% - 20px)`}>
                <IconButton
                  sx={{ padding:0, fontSize: "20px", color: "#adadad"}}
                >
                  {
                    selectedSection == i ?
                    <KeyboardArrowDown sx={{ padding:0, fontSize: "20px", color: "#1d1d1d" }}/>
                    :
                    <KeyboardArrowRight sx={{ padding:0, fontSize: "20px", color: "#5d5d5d" }}/>
                  }
                </IconButton>
                <Text 
                  justify="flex-start" 
                  isTruncated 
                  height={"24px"} 
                  fontSize={"16px"}
                  color={selectedSection == i ? "#1d1d1d" : "#3d3d3d"}
                  fontWeight={selectedSection == i ? "600" : "regular"}
                >  
                  {data.section_name}
                </Text>
              </HStack>
              {
                getPercentageComplete(data) < 100 ? (
                  <Box
                    marginX={"auto"}
                    width={"64px"}
                    height={"6px"}
                    borderRadius={"4px"}
                    backgroundColor={"#D9D9D9"}
                  >
                    <Box
                      width={`${getPercentageComplete(data)}%`}
                      height={"100%"}
                      borderRadius={"4px"}
                      backgroundColor={
                        getPercentageComplete(data) < 33 ? "#C82A22" :
                        getPercentageComplete(data) < 67 ? "#E69500" :
                        getPercentageComplete(data) < 100 ? "#009652" :
                        "#2584FD"
                      }
                    />
                  </Box>
                  ) : (
                    <IconButton sx={{ padding:0, "&:hover":{backgroundColor: "transparent"}}} ><CheckCircleOutlined sx={{ padding:0, fontSize: 16, color: "#009652" }}/></IconButton>
                  )
              }
            </HStack>
          </Button>
          {
          true && (
            <ShowHelperButton 
              i={i} 
              selectedSection={selectedSection} 
              setSelectedSection={setSelectedSection} 
              buttonType={"unfilled"} 
              setScrollToQuestionCard={setScrollToQuestionCard}
              setSelectedTab={setSelectedTab}
              count={getUnfilledAnswers(data)} 
              section={data}
              selectedFilter={selectedFilter}
              setSelectedFilter={setSelectedFilter}
            />
          )
          }
          {
          true && (
            <ShowHelperButton 
              i={i} 
              selectedSection={selectedSection} 
              setSelectedSection={setSelectedSection} 
              buttonType={"unreviewed"} 
              setScrollToQuestionCard={setScrollToQuestionCard}
              setSelectedTab={setSelectedTab}
              count={getUnreviewedAnswers(data)} 
              section={data}
              selectedFilter={selectedFilter}
              setSelectedFilter={setSelectedFilter}
            />
          )
          }
          {
          true && (
            <ShowHelperButton 
              i={i} 
              selectedSection={selectedSection} 
              setSelectedSection={setSelectedSection} 
              buttonType={"completed"} 
              setScrollToQuestionCard={setScrollToQuestionCard}
              setSelectedTab={setSelectedTab}
              count={getCompletedAnswers(data)} 
              section={data}
              selectedFilter={selectedFilter}
              setSelectedFilter={setSelectedFilter}
            />
          )
          }
        </VStack>
        ))}
      </VStack>
      <VStack>
        <Text>
          {/* Test */}
        </Text>
      </VStack>
      </GridItem>
    )
}

const ShowHelperButton = ({
  i,
  selectedSection, 
  setSelectedSection,
  buttonType,
  count,
  setSelectedTab,
  section,
  setScrollToQuestionCard,
  selectedFilter,
  setSelectedFilter,
}) => {
  const [questionCards, setQuestionCards] = React.useState([])
  let [clickCount, setClickCount] = React.useState(0)
  function getText() {
    switch (buttonType) {
      case "unfilled": {
        return "Needs input"
      }
      case "unreviewed": {
        return "Needs review"
      }
      case "completed": {
        return "Completed"
      }
    }
  }

  React.useEffect(() => {
    switch (buttonType) {
      case "unfilled": {
        setUnfilledQuestionCards(section)
        return
      }
      case "unreviewed": {
        setUnreviewedQuestionCards(section)
        return
      }
    }

  }, [section])

  function setUnfilledQuestionCards(section) {
    console.log("[Form][BottomLeft] section data is", section)
    let questionCards = [];
    for (let i = 0; i < section.fill_response?.length; i++) {
      if (section.fill_response[i].state == "unfilled") {
        questionCards = [...questionCards, {id: section.fill_response[i].id, tab: "fill"}]
      }
    }

    for (let i = 0; i < section.review_response?.length; i++) {
      if (section.review_response[i].state == "unfilled") {
        questionCards = [...questionCards, {id: section.review_response[i].id, tab: "review"}]
      }
    }

    setQuestionCards(questionCards)
  }

  function setUnreviewedQuestionCards(section) {
    console.log("[Form][BottomLeft] section data is", section)
    let questionCards = [];
    for (let i = 0; i < section.fill_response?.length; i++) {
      if (section.fill_response[i].state == "unapproved") {
        questionCards = [...questionCards, {id: section.fill_response[i].id, tab: "fill"}]
      }
    }

    for (let i = 0; i < section.review_response?.length; i++) {
      if (section.review_response[i].state == "unapproved") {
        questionCards = [...questionCards, {id: section.review_response[i].id, tab:"review"}]
      }
    }

    setQuestionCards(questionCards)
  }

  function navigateToQuestionCard(i) {
    if (questionCards.length == 0) {
      setSelectedSection(i)
      return
    }
    console.log("[Form][Bottom Left] question cards are", questionCards)
    console.log("[Form][Bottom Left] question card index is", questionCards[clickCount%(questionCards.length)])
    setScrollToQuestionCard(questionCards[clickCount%(questionCards.length)].id)
    setSelectedTab(questionCards[clickCount%(questionCards.length)].tab)
    clickCount++
    if (clickCount >= questionCards.length) {
      clickCount = clickCount - questionCards.length
    }
    setClickCount(clickCount)

    setSelectedSection(i)
  }

  return (
    <>
    {selectedSection == i && (
      <AnimatePresence>
      <motion.div
        initial={{ y: '0%', opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        // exit={{ y: '100%', opacity: 0 }}
        transition={{ type: 'tween', duration: 0.2 }}
        style={{ flex: '1', overflow: 'hidden', width: "100%" }}
      >
        <Box
          display={"flex"}
          justifyContent="space-between"
          alignItems="center"
          colorScheme="#F6FAFF"
          border="none"
          // borderLeft={selectedFilter == buttonType ? "4px solid #2584fd" : "4px solid #E5E5E5"}
          borderRadius="0"
          color= {selectedFilter == buttonType ? "#1d1d1d" : "#5d5d5d"}
          paddingY={"14px"}
          marginLeft={"8px"}
          fontWeight={selectedFilter == buttonType ? "600" : "regular"}
          // bg={"white"}
          // width="100%"
          sx = {{
            width: "100%",
            height: "24px",
          }}
          width={"100%"}
          height={"24px"}
          paddingLeft={"16px"}
          paddingRight={"12px"}
          _hover={{
            // backgroundColor: 'blue.500',  // Change background on hover
            // color: '#2584fd',  // Change text color on hover
            // borderLeft: "4px solid #2584fd",
            // color: '#1D1D1D',
            // fontWeight: "600",
            pointer: "default"
          }}
          key={i}
          // onClick={() => setSelectedFilter(buttonType)}
        >
          <Flex justify={"flex-start"}>
            {/* <IconButton 
              sx={{ padding:0, fontSize: "16px", color: "#adadad"}}
            ><KeyboardArrowRightIcon sx={{ padding:0, fontSize: "16px", color: "#8d8d8d" }}/></IconButton> */}
            <Text fontFamily={"sans-serif"} fontSize={"14px"}>
              {getText()}
            </Text>
          </Flex>
          <Flex justify={"flex-end"}>
            <Text fontFamily={"sans-serif"} fontSize={"14px"}>
              {count}
            </Text>
          </Flex>
        </Box>
      </motion.div>
      </AnimatePresence>
    )}
    </>
  )
}

export default BottomLeft;